import React from "react";
import './footer.css'

class Footer extends React.Component {
    render() {
        return (
            <div className="footer row-line">


                <div className="block-footer1">
                    <a className="linkfoot" href="/contact">Nous contacter</a>
                    <a className="linkfoot" href="/mentions">Mentions légales</a>
                </div>

                <div className="block-footer2">
                    <a className="linkfoot" href="/partenaires">Nos partenaires</a>
                    <a className="linkfoot" href="/apropos">A propos</a>
                </div>
            </div>

        )
    }
}

export default Footer;
